import { render, staticRenderFns } from "./customLoadingComponent.vue?vue&type=template&id=0d653c15"
import script from "./customLoadingComponent.vue?vue&type=script&lang=js"
export * from "./customLoadingComponent.vue?vue&type=script&lang=js"
import style0 from "./customLoadingComponent.vue?vue&type=style&index=0&id=0d653c15&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports